import { render, staticRenderFns } from "./field-card-valid-date.vue?vue&type=template&id=2ec87d78&scoped=true"
import script from "./field-card-valid-date.vue?vue&type=script&lang=js"
export * from "./field-card-valid-date.vue?vue&type=script&lang=js"
import style0 from "./field-card-valid-date.vue?vue&type=style&index=0&id=2ec87d78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec87d78",
  null
  
)

export default component.exports